import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useContext } from "react";

import { AuthenticatedView } from "@/shared/components/AuthenticatedView";
import { AuthenticatorContext } from "@/shared/components/Authenticator";

export const Route = createFileRoute("/_authenticated")({
  component: Authenticated,
});

function Authenticated() {
  const authCtx = useContext(AuthenticatorContext);
  if (!authCtx.user) {
    return <Navigate to="/sign-in" />;
  }
  return <AuthenticatedView />;
}
